var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-table',{attrs:{"items":_vm.airports,"fields":_vm.fields},scopedSlots:_vm._u([{key:"name",fn:function(ref){
var item = ref.item;
return [_c('router-link',{attrs:{"to":{ name: 'airports.edit', params: { id: item.id } }}},[_vm._v(" "+_vm._s(item.name)+" ")])]}},{key:"is_main",fn:function(ref){
var item = ref.item;
return [(item.is_main)?_c('i',{staticClass:"icon-checkmark text-success"}):_c('span')]}},{key:"actions",fn:function(ref){
var item = ref.item;
return [_c('b-button',{attrs:{"variant":"danger","size":"sm"},on:{"click":function($event){return _vm.deleteAction(item)}}},[_c('i',{staticClass:"icon-trash"}),_vm._v(" "+_vm._s(_vm.$t('general.delete'))+" ")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }